import type { AsyncStorage } from '@tanstack/query-persist-client-core';
import type { Table } from 'dexie';

import Dexie from 'dexie';

export class PersisterDexieStorage implements AsyncStorage {
    private db: Dexie;
    private table: Table<{ key: string; value: string }, string>;

    constructor(dbName = 'persisterDexieStorage', tableName = 'table') {
        this.db = new Dexie(dbName);

        this.db.version(1).stores({
            [tableName]: '&key',
        });

        this.table = this.db.table(tableName);
    }

    async getItem(key: string): Promise<string | null> {
        const row = await this.table.get(key);

        return row?.value ?? null;
    }

    async setItem(key: string, value: string): Promise<void> {
        await this.table.put({ key, value });
    }

    async removeItem(key: string): Promise<void> {
        await this.table.delete(key);
    }

    async clear(): Promise<void> {
        await this.table.clear();
    }

    async getAllKeys(): Promise<string[]> {
        const rows = await this.table.toArray();

        return rows.map(row => row.key);
    }
}

export const persisterDexieStorage = new PersisterDexieStorage('persisterDexieStorage', 'table');
